import moment from 'moment';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

const OverViewColumns = ({
  data = {},
  numRows = [],
  emailRows = [],
  priceFields = [],
  dateFields = [],
  dateTimeFields = [],
  fieldsToShow = [],
  md = 3,
  mt = 1,
  className = '',
  fontSize = 'xsmallFont'
}) => {
  const getValue = (key, isObject, objectKey, isArray) => {
    if (isArray) {
      const value = data[key]?.length > 0 ? data[key].map(a => a?.[objectKey]).join(',') : 'N/A';
      return value;
    }
    let value = isObject ? data[key]?.[objectKey] : data[key];
    if (typeof value !== 'boolean' && value !== 0 && !value) return 'N/A';

    if (typeof value === 'boolean') {
      value = value ? 'Yes' : 'No';
    }

    if (emailRows.includes(key)) {
      return (
        <a onClick={e => e.stopPropagation()} className="text-info" href={`mailto:${value}`}>
          {value}
        </a>
      );
    }

    if (numRows.includes(key)) {
      return (
        <a onClick={e => e.stopPropagation()} className="text-info" href={`tel:${value}`}>
          {value}
        </a>
      );
    }
    if (dateFields.includes(key)) {
      return moment(value).format('MMMM Do, YYYY');
    }
    if (dateTimeFields.includes(key)) {
      return moment(value).format('MMMM Do, YYYY hh:mm a');
    }

    if (priceFields.includes(key)) {
      return `$${value}`;
    }
    return Array.isArray(value) ? value.join(', ') : value;
  };

  return (
    <Row noGutters className={`${className} d-flex`}>
      {fieldsToShow.map(field => {
        const key = typeof field !== 'string' ? field.key : field;
        const label = typeof field !== 'string' ? field.label : field;

        return (
          <Col xs={12} md={md} className={`d-flex flex-column mt-${mt} px-2 ${fontSize}`}>
            <p className="mb-0 text-dark">
              <span className="text-muted mid">{label}: </span>
            </p>
            <p className="mb-0 text-dark px-2 py-1 large bg-primary-light rounded flex-grow-1 d-flex align-items-center">
              {data[key] ? getValue(key, field.isObject, field.objectKey, field.isArray) : 'N/A'}
            </p>
          </Col>
        );
      })}
    </Row>
  );
};

export default OverViewColumns;
